// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OrderBook – orders list */
.orderbook-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.orderbook-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.orderbook-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.orderbook-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.orderbook-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.orderbook-section__stats {
  display: flex;
  gap: 1.25rem;
}

.orderbook-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.orderbook-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.orderbook-section__stats--actions {
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.orderbook-export-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);
  color: #166534;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, box-shadow 0.2s;
}

.orderbook-export-btn:hover:not(:disabled) {
  background: #dcfce7;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.orderbook-export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.orderbook-refresh-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.orderbook-refresh-btn:hover:not(:disabled) {
  border-color: #0f766e;
  color: #0f766e;
}

.orderbook-refresh-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.orderbook-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  flex: 0 1 120px;
}

.orderbook-page-limit__select,
.orderbook-status-select {
  max-width: none;
  margin: 0;
  min-width: 100px;
  flex: 0 1 160px;
}

.orderbook-toast {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 9999;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.orderbook-toast--success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.orderbook-toast--error {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.orderbook-search-wrap {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.orderbook-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.orderbook-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.orderbook-search-input::placeholder {
  color: var(--text-muted);
}

.orderbook-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.orderbook-table-wrap {
  overflow-x: auto;
}

.orderbook-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.orderbook-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.orderbook-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.orderbook-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.orderbook-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.orderbook-table tbody tr:hover {
  background: #f0fdfa !important;
}

.orderbook-table tbody tr:last-child td {
  border-bottom: none;
}

.orderbook-order-id {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.orderbook-user-link {
  color: #dc2626;
  font-weight: 600;
  text-decoration: none;
}

.orderbook-user-link:hover {
  text-decoration: underline;
}

.orderbook-side {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.orderbook-side--buy {
  background: #dcfce7;
  color: #166534;
}

.orderbook-side--sell {
  background: #fef2f2;
  color: #b91c1c;
}

.orderbook-status {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
}

.orderbook-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.orderbook-status--partial {
  background: #e0f2fe;
  color: #0369a1;
}

.orderbook-status--filled {
  background: #dcfce7;
  color: #166534;
}

.orderbook-status--cancelled {
  background: #f1f5f9;
  color: #64748b;
}

.orderbook-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

.orderbook-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
}

.orderbook-pagination__info {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.orderbook-pagination__buttons {
  display: flex;
  gap: 0.5rem;
}

.orderbook-pagination__btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.orderbook-pagination__btn:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
}

.orderbook-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/OrderBookPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* OrderBook – orders list */\n.orderbook-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.orderbook-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.orderbook-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.orderbook-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.orderbook-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.orderbook-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.orderbook-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.orderbook-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.orderbook-section__stats--actions {\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.orderbook-export-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);\n  color: #166534;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.orderbook-export-btn:hover:not(:disabled) {\n  background: #dcfce7;\n  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);\n}\n\n.orderbook-export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.orderbook-refresh-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.orderbook-refresh-btn:hover:not(:disabled) {\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.orderbook-refresh-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.orderbook-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex: 0 1 120px;\n}\n\n.orderbook-page-limit__select,\n.orderbook-status-select {\n  max-width: none;\n  margin: 0;\n  min-width: 100px;\n  flex: 0 1 160px;\n}\n\n.orderbook-toast {\n  position: fixed;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 9999;\n  padding: 0.75rem 1.25rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.orderbook-toast--success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.orderbook-toast--error {\n  background: #fee2e2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.orderbook-search-wrap {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.orderbook-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.orderbook-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.orderbook-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.orderbook-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.orderbook-table-wrap {\n  overflow-x: auto;\n}\n\n.orderbook-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.orderbook-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.orderbook-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.orderbook-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.orderbook-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.orderbook-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.orderbook-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.orderbook-order-id {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.orderbook-user-link {\n  color: #dc2626;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.orderbook-user-link:hover {\n  text-decoration: underline;\n}\n\n.orderbook-side {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.orderbook-side--buy {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.orderbook-side--sell {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.orderbook-status {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.orderbook-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.orderbook-status--partial {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.orderbook-status--filled {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.orderbook-status--cancelled {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.orderbook-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.orderbook-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border);\n}\n\n.orderbook-pagination__info {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.orderbook-pagination__buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.orderbook-pagination__btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.orderbook-pagination__btn:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n  border-color: #0f766e;\n}\n\n.orderbook-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
